import React from "react";
import { StyledButton } from "@aureskonnect/react-ui";
import { useSelector } from "react-redux";

export function CustomMainColorButton(props: any) {
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    return (
        <StyledButton
            className="text-white"
            {...props}
            style={{ backgroundColor: mainColor }}
        />
    );
}
